import * as yup from 'yup';

// Documentation for schemas: https://github.com/jquense/yup?tab=readme-ov-file#schema

export function validateSync<T extends yup.Maybe<yup.AnyObject>>({
  schema,
  values,
  onError,
  onSuccess,
}: {
  schema: yup.ObjectSchema<T>;
  values: T;
  onError: (err: yup.ValidationError) => void;
  onSuccess: () => void;
}) {
  try {
    schema.validateSync(values, { abortEarly: false });
    onSuccess();
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      onError(err);
    } else {
      throw err;
    }
  }
}

export async function validateAsync<T extends yup.Maybe<yup.AnyObject>>({
  schema,
  values,
  onError,
  onSuccess,
}: {
  schema: yup.ObjectSchema<T>;
  values: T;
  onError: (err: yup.ValidationError) => void;
  onSuccess: () => void;
}) {
  try {
    await schema.validate(values, { abortEarly: false });
    onSuccess();
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      onError(err);
    } else {
      throw err;
    }
  }
}

export { yup };
